<template>
	<a :class="{ 'has-icon': !hideIcon }" :href="href" class="object-link" ref="link"
		><!-- tabindex="-1"-->
		<span class="object-link-text"><slot></slot></span>
		<icon
			class="right"
			color="inherit"
			type="chevron-right"
			v-if="!hideIcon"
			v-tooltip="trans('actions.show')"
			tabindex="-1"
		></icon>
	</a>
</template>

<script type="text/babel">
export default {
	props: {
		icon: { default: null }, // icon name (file)
		hideIcon: { default: false },
		href: { default: "#" },
	},

	computed: {
		hasIcon() {
			// todo remove this eventually?
			return this.icon !== null;
		},
	},
};
</script>
